import { render, staticRenderFns } from "./proforma-agen-print.vue?vue&type=template&id=a1001b30&scoped=true"
import script from "./proforma-agen-print.vue?vue&type=script&lang=js"
export * from "./proforma-agen-print.vue?vue&type=script&lang=js"
import style0 from "./proforma-agen-print.vue?vue&type=style&index=0&id=a1001b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1001b30",
  null
  
)

export default component.exports